import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    links: PropTypes.arrayOf(
        PropTypes.shape(
            {
                url: PropTypes.string.isRequired,
                title: PropTypes.string.isRequired,
                description: PropTypes.string.isRequired
            }))
};

class AdditionalLinks extends React.Component {
    render() {
        const { links } = this.props;
        if (!(links && links.length)) {
            return null;
        }

        const linkList = links.map((link) => (
            <li key={link.url}>
                <a href={link.url} rel="noopener noreferrer" target="_blank">
                    {link.description ? link.description : link.title}
                </a>
            </li>
        ));

        return (
            <div className="rec-aside-body rec-aside-box">
                <h5>Additional Information</h5>
                <ul className="additional-links">{linkList}</ul>
            </div>
        );
    }
}

AdditionalLinks.propTypes = propTypes;

export default AdditionalLinks;